class Cost {
	id = null;
	teacher_id = null;
	planned_course_id = null;
	teacher_activity_id = null;
	description = '';
	date = null;
	unit_price = null;
	quantity = 1;
	is_teacher_hourly_rate_cost = false;
	cost_file = {
		name: '',
		link: '',
		original_name: '',
		upload_id: null,
	};

	constructor(data, validation = false) {
		for (const [key, value] of Object.entries(data)) {
			this[key] = value;
		}

		if (validation) {
			for (const [key, value] of Object.entries(this)) {
				this[key] = true;
			}
		}
	}
}

export default Cost;
